import { ADD_DATA_SOURCES, CLEAR_DATA_SOURCES, SET_DS_FETCHING } from "./types";

export const setDsFetching = () => {
  return {
    type: SET_DS_FETCHING,
  };
};

//Set Datasources
export const addDataSources = (dataSources) => {
  return {
    type: ADD_DATA_SOURCES,
    payload: dataSources,
  };
};

//clear Datasources
export const clearDataSources = () => {
  return {
    type: CLEAR_DATA_SOURCES,
  };
};
